/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { useEffect, useState } from 'react'
import { Button } from '@hashicorp/mds-react'
import { parseLIUrl } from './utils'
import s from './style.module.css'

export default function LinkedInEmbed({ url }) {
	const [html, setHtml] = useState('')

	// Get HTML for the embed from our iframe-embed-adjustment-proxy API route
	useEffect(() => {
		if (html === '') {
			const getData = async () => {
				const res = await fetch(
					`/api/iframe-embed-adjustment-proxy?url=https://www.linkedin.com/embed/feed/update/urn:li:${urnType}:${id}`,
				)

				const { body } = await res.json()
				setHtml(body)
			}
			getData()
		}
	}, [])

	const { urnType, id } = parseLIUrl(url)

	return (
		<div className={s.linkedinEmbed}>
			{urnType !== '' && id !== '' && !html.startsWith('error: ') ? (
				<div
					className={s.iframe}
					title="Embedded LinkedIn post"
					dangerouslySetInnerHTML={{ __html: html }}
				></div>
			) : (
				<div className={s.fallback}>
					<Button
						type="button"
						href={url}
						isHrefExternal={true}
						text="Visit LinkedIn post"
						icon="external-link"
						iconPosition="trailing"
						color="secondary"
					/>
				</div>
			)}
		</div>
	)
}
